var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import { darken, lighten, makeStyles } from '@material-ui/core/styles';
import { capitalize } from '@material-ui/core/utils';
import { LinearProgress } from '@material-ui/core';
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => {
    const isLight = theme.palette.mode === 'light';
    const gradientDashed = (color) => {
        const getColor = isLight ? lighten(color, 0.62) : darken(color, 0.5);
        return `radial-gradient(${getColor} 0%, ${getColor}  16%, transparent 42%)`;
    };
    const createStyle = (color) => {
        return {
            '& .MuiLinearProgress-bar': {
                backgroundColor: theme.palette[color].main
            },
            '&.MuiLinearProgress-indeterminate, &.MuiLinearProgress-determinate, & .MuiLinearProgress-bar2Buffer, &.MuiLinearProgress-query': {
                backgroundColor: isLight
                    ? theme.palette[color].lighter
                    : theme.palette[color].darker
            },
            '& .MuiLinearProgress-dashed': {
                backgroundImage: gradientDashed(theme.palette[color].main)
            }
        };
    };
    return {
        colorInfo: createStyle('info'),
        colorSuccess: createStyle('success'),
        colorWarning: createStyle('warning'),
        colorError: createStyle('error')
    };
});
export const MLinearProgress = (_a) => {
    var { className, color = 'primary' } = _a, other = __rest(_a, ["className", "color"]);
    const classes = useStyles();
    if (color === 'primary' || color === 'secondary') {
        return React.createElement(LinearProgress, Object.assign({ color: color, className: className }, other));
    }
    return (React.createElement(LinearProgress, Object.assign({ className: clsx({
            [classes[`color${capitalize(color)}`]]: color
        }, className) }, other)));
};
//# sourceMappingURL=MLinearProgress.js.map